<div class="operator-container">
    <ng-container *ngIf="view === 'Measures' then PERIOD_OPERATOR else FIELD_OPERATOR"></ng-container>
    <ng-template #PERIOD_OPERATOR>
                <lm-field-picker-period-operator
            [uiFieldSpec]="uiFieldSpec"
            [operatorInfo]="operatorInfo"
            [validPeriods]="validPeriods"
            (operatorChangedEvent)= "onOperatorChange($event)">
        </lm-field-picker-period-operator>
    </ng-template>
    <ng-template #FIELD_OPERATOR>
        <lm-field-picker-field-operator #FieldOperatorView
            [uiFieldSpec]="uiFieldSpec"
            [operatorInfo]="operatorInfo"
            [auditData]="auditData"
            (operatorChangedEvent)= "onOperatorChange($event)">
        </lm-field-picker-field-operator>
    </ng-template>
    <div class="" [ngClass]="{'form-layout-compact': useCompactFormLayout}">
        <div class="field">
            <label soho-label for="lplName">{{ 'FieldPicker_FieldPreviewLabel' | translate }}</label>
            <p data-automation-id="lm-field-picker-preview-name" id="lplName" [ngClass]="{'form-layout-compact': useCompactFormLayout}"><b>{{lplName}}</b></p>
        </div>
        <div *ngIf="operatorExample" class="field">
            <label soho-label for="lplName">{{ 'FieldPicker_OperatorExampleLabel' | translate }}</label>
            <p data-automation-id="lm-field-picker-format-example" id="operatorExample" [ngClass]="{'form-layout-compact': useCompactFormLayout}"><b>{{operatorExample}}</b></p>
        </div>
    </div>
</div>